import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_INTERACTION } from '.';

const CREDIT_HOLD_OUTSTANDING_INVOICES =
  'ecaja-credit-hold-outstanding-invoices';
export const creditHoldOutstandingInvoicesInteracted: TealiumEventData = {
  linkName: CREDIT_HOLD_OUTSTANDING_INVOICES,
  eventName: [CREDIT_HOLD_OUTSTANDING_INVOICES, EVENT_NAME_INTERACTION],
};

const CREDIT_HOLD_HELP_CENTRE = 'ecaja-credit-hold-help-centre';
export const creditHoldHelpCentreInteracted: TealiumEventData = {
  linkName: CREDIT_HOLD_HELP_CENTRE,
  eventName: [CREDIT_HOLD_HELP_CENTRE, EVENT_NAME_INTERACTION],
};
